import { t } from "@/i18n-js/instance";
import { LoadingIndicator } from "./LoadingIndicator";

export const InitializingIndicator = () => (
  <LoadingIndicator label={t("live_streams.room.initializing")} />
);
